import React from 'react';
import { motion } from 'framer-motion';
import { TagIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function PricingSection() {
  const originalPrice = 18;
  const discountedPrice = 6.39;
  const discountPercentage = Math.round((originalPrice - discountedPrice) / originalPrice * 100);
  return <section id="pricing" className="w-full bg-[#FBF9F6] py-16 md:py-24 px-4" data-id="element-78">
      <div className="max-w-4xl mx-auto" data-id="element-79">
        <motion.div className="text-center mb-12" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-80">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2C2C2C] mb-4" data-id="element-81">
            Empieza hoy
          </h2>
          <p className="text-xl text-[#5C5C5C]" data-id="element-82">
            Descarga inmediata. Sin suscripciones. Sin letra chica.
          </p>
        </motion.div>

        <motion.div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 border-4 border-[#C7E0E7] relative overflow-hidden" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-83">
          {/* Guía Digital PDF Badge - Positioned on the left */}
          <div className="absolute top-6 left-6" data-id="element-84">
            <div className="bg-[#C7E0E7]/10 px-6 py-2 rounded-full" data-id="element-85">
              <span className="text-[#C7E0E7] font-semibold" data-id="element-86">
                Guía Digital PDF
              </span>
            </div>
          </div>

          {/* Discount Badge - Positioned on the right */}
          <div className="absolute top-6 right-6" data-id="element-87">
            <motion.div className="bg-gradient-to-br from-red-500 to-red-600 text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2" initial={{
            scale: 0,
            rotate: -10
          }} whileInView={{
            scale: 1,
            rotate: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4,
            type: 'spring'
          }} data-id="element-88">
              <TagIcon className="h-5 w-5" aria-hidden="true" data-id="element-89" />
              <span className="font-bold text-lg" data-id="element-90">-{discountPercentage}%</span>
            </motion.div>
          </div>

          <div className="text-center pt-8" data-id="element-91">
            {/* Price Display */}
            <div className="mb-4" data-id="element-92">
              <div className="flex items-center justify-center gap-4 mb-2" data-id="element-93">
                <span className="text-2xl md:text-3xl text-[#5C5C5C] line-through opacity-60" data-id="element-94">
                  USD ${originalPrice}
                </span>
                <motion.div initial={{
                scale: 0.8,
                opacity: 0
              }} whileInView={{
                scale: 1,
                opacity: 1
              }} viewport={{
                once: true
              }} transition={{
                duration: 0.4,
                delay: 0.3
              }} data-id="element-95">
                  <h3 className="text-5xl md:text-6xl font-bold text-[#2C2C2C]" data-id="element-96">
                    USD ${discountedPrice}
                  </h3>
                </motion.div>
              </div>
              <p className="text-red-600 font-semibold text-lg" data-id="element-97">
                ¡Ahorra ${(originalPrice - discountedPrice).toFixed(2)}!
              </p>
            </div>

            <p className="text-lg text-[#5C5C5C] mb-8" data-id="element-98">
              Pago único. Acceso inmediato.
            </p>

            <CTAButton href="https://www.consejossimples.com/cart/53362651169101:1" className="w-full md:w-auto" ariaLabel="Descargar Plan" data-id="element-99">
              Descargar Plan
            </CTAButton>
          </div>
        </motion.div>
      </div>
    </section>;
}